import type { Step } from "react-joyride";

export const payrollListTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າເງິນເດືອນ. ທ່ານສາມາດຈັດການເງິນເດືອນຕາມເດືອນ, ຢືນຢັນ ແລະ ຊຳລະພະນັກງານຈາກຫນ້ານີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="payroll-list-toolbar"]',
    content:
      "ເບິ່ງເງິນເດືອນຕາມເດືອນ ຫຼື ສ້າງລາຍການເງິນເດືອນໃໝ່. ກົດ 'ທົດລອງທົດສອບ' ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="payroll-list-summary"]',
    content:
      "ສະຫຼຸບ: ລວມລາຍການທີ່ຊຳລະແລ້ວ, ລໍຖ້າອະນຸມັດ ແລະ ເງິນເດືອນຮ່າງ (ຈຳນວນພະນັກງານ).",
    placement: "bottom",
  },
  {
    target: '[data-tourid="payroll-list-filter"]',
    content:
      "ກັ່ນຕອງຕາມສະຖານະ (ຮ່າງ / ຢືນຢັນ / ຊຳລະແລ້ວ) ແລະ ຄົ້ນຫາພະນັກງານ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="payroll-list-table"]',
    content:
      "ຕາຕະລາງເງິນເດືອນ. ກົດແຖວເພື່ອແກ້ໄຂ ຫຼື ເບິ່ງໃບ slip. ທ່ານສາມາດຢືນຢັນ, ຊຳລະ ຫຼື ລຶບ (ສະຖານະຮ່າງ) ຈາກປຸ່ມການກະທຳ.",
    placement: "top",
  },
];
